<div class="bet-radar-iframe-scroll"><iframe class="bet-radar-iframe" *ngIf="betRadarUrl" [src]="betRadarUrl"> </iframe></div>
